import authentication from './authentication';

export default { authentication };
